import React, { useState, useEffect } from 'react'
import {
  Btn,
  CustomModal,
  InputNumeroDecimal,
  InputNumeroInteiro,
  InputText,
} from '../../../../../components'
import { errorHandler } from '../../../../../services/util/error.service'
import * as RetornoHttp from '../../../../../services/api/https/deliveries/retorno.http'
import {
  buildSobraQuantityInputState,
  getSobraInputLabels,
  getSobraQuantityConfig,
  getSobraQuantityValueFromInputs,
} from './sobra-volume-and-units.helper'

function ModalAjusteSobra({ sobra, onSuccess, onModalClose, onError, visible, fleetId }) {
  // Vars
  if (!sobra) return null

  const { qte_adjusted, adjust_justification, leftover_id } = sobra
  const initialQuantityState = buildSobraQuantityInputState(sobra, qte_adjusted)
  const { canUseFractionedInput } = getSobraQuantityConfig(sobra)
  const { volumeLabel, unitsLabel } = getSobraInputLabels(sobra)

  // Hooks
  const [qte, setQte] = useState(initialQuantityState.quantityValue)
  const [volumeValue, setVolumeValue] = useState(initialQuantityState.volumeValue)
  const [unitsValue, setUnitsValue] = useState(initialQuantityState.unitsValue)
  const [justification, setJustification] = useState(
    adjust_justification ? adjust_justification : '',
  )

  useEffect(() => {
    const nextQuantityState = buildSobraQuantityInputState(sobra, qte_adjusted)

    setQte(nextQuantityState.quantityValue)
    setVolumeValue(nextQuantityState.volumeValue)
    setUnitsValue(nextQuantityState.unitsValue)
    setJustification(adjust_justification ? adjust_justification : '')
  }, [sobra, qte_adjusted, adjust_justification])

  const onQuantityChange = (field, value) => {
    const nextVolumeValue = field === 'volume' ? value : volumeValue
    const nextUnitsValue = field === 'units' ? value : unitsValue

    setVolumeValue(nextVolumeValue)
    setUnitsValue(nextUnitsValue)
    setQte(getSobraQuantityValueFromInputs(sobra, nextVolumeValue, nextUnitsValue))
  }

  // Events
  const onBtnSalvarClicked = async () => {
    const qteAdjusted = Number(qte || 0)

    if (qteAdjusted !== 0 && justification.trim().length <= 5) {
      onError('A justificativa deve conter pelo menos 5 caracteres')
      return
    }

    if (Number(sobra.qte_leftover) + qteAdjusted < 0) {
      onError('Quantidade para Correção não pode tornar a sobra menor que zero')
      return
    }

    try {
      const updatedSobra = {
        qte_adjusted: qteAdjusted === 0 ? null : qteAdjusted,
        adjust_justification: qteAdjusted === 0 ? null : justification,
        fleet_id: fleetId,
      }
      await RetornoHttp.putLeftoverProductQteAdjusted(leftover_id, updatedSobra)
      onSuccess({ ...sobra, ...updatedSobra })
    } catch (e) {
      onError(errorHandler(e))
    }
  }

  // Render
  return (
    <CustomModal
      header="Ajuste da Quantidade da Ocorrência"
      isVisible={visible}
      onClose={onModalClose}
    >
      <form className="p-grid">
        <div className="p-col-3">
          {canUseFractionedInput ? (
            <InputNumeroInteiro
              label={volumeLabel}
              marginTop={10}
              value={volumeValue}
              onChange={value => onQuantityChange('volume', value)}
            />
          ) : (
            <InputNumeroDecimal
              label={volumeLabel}
              marginTop={10}
              value={volumeValue}
              onChange={value => onQuantityChange('volume', value)}
            />
          )}
        </div>
        <div className="p-col-3">
          <InputNumeroInteiro
            label={unitsLabel}
            marginTop={10}
            value={unitsValue}
            onChange={value => onQuantityChange('units', value)}
            disabled={!canUseFractionedInput}
          />
        </div>
        <div className="p-col-6">
          <InputText
            label="Justificativa :"
            marginTop={10}
            value={justification}
            onChange={value => setJustification(value)}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default ModalAjusteSobra
